import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import ActionView from './views/ActionView';

class Action extends React.Component {
    static propTypes = {
        spinner: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const actview = new ActionView();
        $('#action_component').html($(actview.el));
        actview.render();
        this.props.spinner(false);
    }

    render() {
        return (
            <div id="action_component" />
        );
    }
}

export default Action;
